import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyRequestModel } from '../models/request/company-request';
import { TestDocuwareConnectionModel } from '../models/request/test-docuware-connection-model';
import { CompanyResponseModel } from '../models/response/company-response';
import { ResultOfT } from '../models/response/result';
import { ClientCredentialsModel } from '../models/response/userInfo-response';
import { BaseService } from './base.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Constants } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseService{

  constructor(httpService: HttpClient, private router: Router) {
    super(httpService);
  }

  private cacheOwner: string;
  private allCompaniesCache: ResultOfT<CompanyResponseModel[]>;
  private companyByIdCache = new Map<number, ResultOfT<CompanyResponseModel>>();

  clearCache() {
    this.allCompaniesCache = null;
    this.companyByIdCache.clear();
  }

  // Drops the cache when the logged-in user (stored token) changes.
  private validateCacheOwner() {
    const owner = localStorage.getItem(Constants.currentUserToken);
    if (owner !== this.cacheOwner) {
      this.clearCache();
      this.cacheOwner = owner;
    }
  }

  getAllCompanies(): Observable<ResultOfT<CompanyResponseModel[]>> {
    this.validateCacheOwner();
    if (this.allCompaniesCache) {
      return of(this.allCompaniesCache);
    }
    return this.get<ResultOfT<CompanyResponseModel[]>>('Company/GetAllCompanies').pipe(
      tap(result => { if (result?.IsSuccess) { this.allCompaniesCache = result; } })
    );
  }

  getCompanyById(companyId: number): Observable<ResultOfT<CompanyResponseModel>> {
    this.validateCacheOwner();
    const cached = this.companyByIdCache.get(companyId);
    if (cached) {
      return of(cached);
    }
    return this.get<ResultOfT<CompanyResponseModel>>('Company/GetCompanyById/' + companyId).pipe(
      tap(result => { if (result?.IsSuccess) { this.companyByIdCache.set(companyId, result); } })
    );
  }

  getStorageInfoByCompanyId(companyId: number) {
    return this.get<ResultOfT<string>>('Company/GetStorageByCompanyId/' + companyId);
  }

  addCompany(reqModel: CompanyRequestModel){
    return this.post<ResultOfT<CompanyResponseModel>>('Company/AddCompany', reqModel).pipe(tap(() => this.clearCache()));
  }

  updateCompany(reqModel: CompanyRequestModel){
    return this.post<ResultOfT<CompanyResponseModel>>('Company/UpdateCompany' , reqModel).pipe(tap(() => this.clearCache()));
  }

  deleteCompany(companyId: number, modifiedBy: number) {
    return this.get<ResultOfT<boolean>>('Company/DeleteCompany/' + companyId + '/' + modifiedBy).pipe(tap(() => this.clearCache()));
  }

  testDocuwareConnection(reqModel: TestDocuwareConnectionModel){
    return this.post<ResultOfT<any>>('Company/TestDocuwareConnection', reqModel);
  }
  GenreateClientCredentials() {
    return this.get<ResultOfT<ClientCredentialsModel>>('Company/GenreateClientCredentials');
  }

  GenreateClientCredentialsWithUserInfo(companyId: number, modifiedBy: number) {
    return this.get<ResultOfT<ClientCredentialsModel>>('Company/GenreateClientCredentialsWithUserInfo' + '/' + companyId + '/' + modifiedBy);
  }
  updateClientCredentials(reqModel: CompanyRequestModel) {
    return this.post<ResultOfT<boolean>>('Company/updateClientCredentials', reqModel);
  }
}
